import {useQueryClient} from '@tanstack/react-query';

import {useEventHandler} from '../../../../libs/shared/core/src/helpers/react/hooks/useEventHandler';
import {VacationResponderModel} from '../../../../src/models/api/vacationResponderModel';
import {vacationResponderQueries} from '../queries';

/*
 * Hook.
 */

export function useInvalidateVacationResponderQueries() {
  const queryClient = useQueryClient();

  const byNamespaceAsync = useEventHandler(async (namespace: string) => {
    await Promise.all([
      queryClient.invalidateQueries(vacationResponderQueries.byNamespace(namespace)),
      queryClient.invalidateQueries(vacationResponderQueries.twoByNamespace(namespace)),
    ]);
  });

  const forVacationResponderAsync = useEventHandler(
    async (vacationResponder: Pick<VacationResponderModel, 'id' | 'namespace'>) => {
      await Promise.all([
        queryClient.invalidateQueries(vacationResponderQueries.byId(vacationResponder.id)),
        byNamespaceAsync(vacationResponder.namespace),
      ]);
    },
  );

  return {
    byNamespaceAsync,
    forVacationResponderAsync,
  };
}
